import AppContainer from "./AppContainer";

export default AppContainer;
export type { AppContainerProps } from "./AppContainer";
